import React, { useEffect, useState } from 'react';
import { Button, Checkbox } from '@pmi/dsm-react';
import styles from './settings.module.scss';
import AccountDto from '../../shared/models/AccountModel';
import { ConsentQueryResult } from './models';
import { PMIFormatDate } from '../../shared/helpers';

export interface ConsentMandatoryProps {
  accountData: AccountDto;
  consentData: ConsentQueryResult;

  handleUpdateConsent: (consentFlag: boolean) => void;
}
export default function ConsentMandatory({
  accountData,
  consentData,
  handleUpdateConsent,
}: ConsentMandatoryProps) {
  const [consentFlag, setConsentFlag] = useState(false);
  const onConsentChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setConsentFlag(event.target.checked);
  useEffect(() => {
    if (consentData?.share) {
      setConsentFlag(true);
    }
  }, [consentData]);
  return (
    <div className={styles.consentShareCard}>
      <div className="p-4">
        <div className={`pb-3 ${styles.headerSection}`}>
          Consent to share data with {accountData?.name}
        </div>
        <div className={`pb-3 ${styles.subheaderSection}`}>
          To use {accountData?.name} services through PMI Agreement, you must
          consent to sharing information about your use of PMI products and
          services.
        </div>
        <div className="pb-3">
          <Checkbox
            data-testid="consent-checkbox"
            checked={consentFlag}
            onChange={onConsentChange}
            label={`I agree to share data with ${accountData?.name} for the products and services they provide.`}
            labelClass={styles.checkboxContainer}
          />
        </div>
        <div
          className={`${styles.lastConsentDetails} pb-3`}
          data-testid="consent-details"
        >
          <div>Last Consent:</div>
          <div data-testid="consent-name" data-exclude-lg>
            {consentData?.name}
          </div>
          <div data-testid="consent-email" data-exclude-lg>
            {consentData?.email}
          </div>
          <div>{PMIFormatDate(consentData?.lastUpdated)}</div>
        </div>
        <div className="pb-3">
          <Button
            disabled={consentFlag === !!consentData.share}
            onClick={() => handleUpdateConsent(consentFlag)}
            titleText="Update consent"
            variant="primary"
          />
        </div>
        <div className={styles.footerSection}>
          <em>
            You can opt out of sharing this information at any time but you will
            no longer be able to enroll in new products or services from this
            offering. Products you have already enrolled in will remain
            available to you and your data will be anonymized to{' '}
            {accountData?.name}.
          </em>
        </div>
        <div className={styles.footerSection}>
          <em>
            Opting out will reset your authentication which will log you out.
          </em>
        </div>
      </div>
    </div>
  );
}
